import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const CloseIcon = (props: SvgIconProps) => (
  <CloseOutlinedIcon {...props} fontSize="small" />
);

export default CloseIcon;
